interface StepIndicatorProps {
  label?: string;
  currentStep: number;
  totalSteps?: number;
}

export function StepIndicator({ label, currentStep, totalSteps = 4 }: StepIndicatorProps) {
  return (
    <div className="flex flex-col items-center gap-6 mb-6">
      <div
        className="flex items-center gap-[18px]"
        role="progressbar"
        aria-valuenow={currentStep}
        aria-valuemin={1}
        aria-valuemax={totalSteps}
      >
        {Array.from({ length: totalSteps }, (_, i) => {
          const isActive = i + 1 === currentStep;
          return isActive ? (
            <div
              key={i}
              className="h-[5px] w-[16px] rounded-full"
              style={{
                backgroundImage: 'var(--brand-gradient)',
                boxShadow: 'var(--orange-glow-sm)',
              }}
            />
          ) : (
            <div key={i} className="size-[5px] rounded-full bg-white/30" />
          );
        })}
      </div>
      {label && (
        <p className="font-['Inter',sans-serif] text-xs uppercase tracking-widest text-white">
          {label}
        </p>
      )}
    </div>
  );
}
